const Permissions = {
  PROTOCOLDEVIATIONSBROWSER: 'pd.browser.view',
  ROSTERING_CREDENTIALING: 'rostering.credentialing',
  ROSTERING_CREDENTIALING_APPROVE: 'rostering.credentialing.approve',
  ROSTERING_CREDENTIALING_FILTER: 'rostering.credentialing.filter',
  ROSTERING_CREDENTIALING_GO: 'rostering.credentialing.go',
  ROSTERING_CREDENTIALING_EDIT: 'rostering.credentialing.edit',
  ROSTERING_CREDENTIALING_REQUEST: 'rostering.credentialing.request'
};
export default Permissions;
